document.addEventListener('DOMContentLoaded', () => {
  // Find all search inputs and their corresponding reset buttons
  const searchInputs = document.querySelectorAll('.search__input');

  searchInputs.forEach((searchInput) => {
    // Find the reset button within the same form/field
    const resetBtn = searchInput.closest('.field')?.querySelector('.reset__button') || 
                     searchInput.closest('form')?.querySelector('.reset__button');

    if (!searchInput || !resetBtn) return;

    // Show/hide reset button based on input value
    function updateResetButtonVisibility() {
      if (searchInput.value.trim() !== '') {
        resetBtn.classList.remove('hidden');
      } else {
        resetBtn.classList.add('hidden');
      }
    }

    // Listen for input changes
    searchInput.addEventListener('input', updateResetButtonVisibility);

    // Handle reset button click
    resetBtn.addEventListener('click', (e) => {
      e.preventDefault();
      searchInput.value = '';
      resetBtn.classList.add('hidden');
      searchInput.focus();
    });

    // Initial state
    updateResetButtonVisibility();
  });
});
